import { render, staticRenderFns } from "./ProtocolOnTakeOffControlList.vue?vue&type=template&id=8669acda"
import script from "./ProtocolOnTakeOffControlList.vue?vue&type=script&lang=js"
export * from "./ProtocolOnTakeOffControlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports